import React from "react";
import "./css/Footer.css";
import gmail from "./Images/footer/gmail.png";
import twitter from "./Images/footer/twitter.png";

function Footer() {
  return (
    <div className="footer">
      <footer className="container-footer" id="contact-us">
        <hr />
        <div className="contact-id">
          Contact Us
          <hr />
        </div>
        <div className="links">
          <a
            href="mailto:innominate06@gmail.com"
            target="_blank"
            className="contact" rel="noreferrer"
          >
            <img src={gmail} alt="" className="logo gmail" />
          </a>
          <a
            href="https://twitter.com/innominate_news"
            target="_blank"
            className="contact" rel="noreferrer"
          >
            <img src={twitter} alt="" className="logo twitter" />
          </a>
          {/* <!-- <a href="https://www.instagram.com/xxx/" target="_blank" className="contact"><img
                    src="Images/footer/instagram.png" alt="" className="logo insta"></a> --> */}
        </div>
        <p>
          &copy; 2022 by Innominate | Designed and Operated by{" "}
          <a href="https://www.github.com/Aarnavv" className="git" target="_blank" rel="noreferrer">
            Aarnav Agarwal
          </a>
        </p>
      </footer>
    </div>
  );
}

export default Footer;
